export default "__VITE_ASSET__BLP7Fhij__"